import { useDataProvider } from "react-admin";
import React, { useEffect, useState } from "react";
import { Typography } from "@material-ui/core";
import NotificationTargetReferenceField from "./NotificationTargetReferenceField";
import CustomLabeled from "../../../components/layout/CustomLabeled";

interface IWaveTargetField {
  waveId?: number;
  isMultipleWave?: boolean;
}

const WaveTargetField = ({ waveId, isMultipleWave }: IWaveTargetField) => {
  const provider = useDataProvider();
  const [wave, setWave] = useState<IBusSchedule>();

  useEffect(() => {
    if (waveId && !isMultipleWave) {
      provider
        .getOne("busSchedules", {
          id: waveId,
        })
        .then(({ data }) => {
          setWave(data as IBusSchedule);
        });
    }
  }, [waveId]);

  if (isMultipleWave) {
    return (
      <NotificationTargetReferenceField
        referenceField="busSchedules"
        referenceSourceField="targetIds"
        labelField="Wave Name"
        labelSourceField="name"
        orderBy="name"
        orderType="ASC"
      />
    );
  } else {
    return (
      <CustomLabeled name="Wave Name">
        {wave ? (
          <Typography variant="body2">{wave.name}</Typography>
        ) : (
          <Typography variant="body2">-</Typography>
        )}
      </CustomLabeled>
    );
  }
};

export default WaveTargetField;
